import { render, staticRenderFns } from "./Priorities.vue?vue&type=template&id=4449134d&scoped=true"
import script from "./Priorities.vue?vue&type=script&lang=js"
export * from "./Priorities.vue?vue&type=script&lang=js"
import style0 from "./Priorities.vue?vue&type=style&index=0&id=4449134d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449134d",
  null
  
)

export default component.exports